import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useSubscribeNewsletter() {
  return useMutation({
    mutationFn: (payload) => apiClient({ url: "/news-letter", method: "POST", data: payload })
  });
}
export function useClientOnBoarding() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/client-on-boarding", method: "POST", data: payload })
  });
}
export function useWorkerOnBoarding() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/worker-on-boarding", method: "POST", data: payload })
  });
}
export function useVerifyOtp() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/draft/verify-otp", method: "POST", data: payload })
  });
}
export function useResendOtp() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/draft/resend-otp", method: "POST", data: payload })
  });
}

export function useClientSubmitAgreement() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/submit-agreement", method: "POST", data: payload })
  });
}
export function useWorkerSubmitAgreement() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({
        url: "auth/worker/submit-agreement",
        method: "POST",
        data: payload // FormData or JSON; api-client strips Content-Type for FormData
      })
  });
}

export function useLogin() {
  return useMutation({
    mutationFn: (payload) => apiClient({ url: "auth/login", method: "POST", data: payload })
  });
}
export function useOnBoardingMe() {
  return useMutation({
    mutationFn: (slug) => apiClient({ url: "auth/onboarding/me/" + slug, method: "GET" })
  });
}
export function useForgotPassword() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/forgot-password", method: "POST", data: payload })
  });
}
export function useForgotPasswordVerifyOtp() {
  return useMutation({
    mutationFn: (payload) => apiClient({ url: "auth/verify-otp", method: "POST", data: payload })
  });
}
export function useResetPassword() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/reset-password", method: "POST", data: payload })
  });
}

export function useUpdatePassword() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "auth/update-password", method: "POST", data: payload })
  });
}
